import type { LanguageItem } from '../types/api'

const BASE = '/newspaper/api/v1'

/**
 * Fetches the language configuration (code, name, flag) from the backend.
 */
export async function fetchLanguagesConfig(): Promise<LanguageItem[]> {
  const res = await fetch(`${BASE}/languages-config/`)
  if (!res.ok) throw new Error(`languages-config API error: ${res.status}`)
  const data = await res.json() as { languages: LanguageItem[] }
  return data.languages
}
